export default {
  setMenuItems({ commit }, item) {
    commit('SET_MENU_ITEMS', item)
  }
}